import type { IFetchOrder } from "../types/api/order";

interface IProps {
  storeName: string;
  domain?: "kr" | "intl" | "jp" | "";
  customerId: string;
  orderId: string;
}

// common_get_order_v2
// 반환되는 각각의 라인아이템에 originalQuantity 값만 추가로 반환하는 방식
export const fetchOrder = async ({ storeName, domain = "", customerId, orderId }: IProps): Promise<IFetchOrder | undefined> => {
  const lambdaUrl = "https://k4rtgzhpqwjfuk7yb5rbdmu4fy0qrhvt.lambda-url.ap-northeast-2.on.aws/";
  try {
    const response = await fetch(lambdaUrl, {
      method: "POST",
      body: JSON.stringify({ storeName, domain, customerId, orderId }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IFetchOrder;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
